import permissions from './permission-list'

export default [
  {
    path: '/banners',
    name: 'banners',
    component: () => import('@/views/banners/index.vue'),
    meta: {
      pageTitle: 'Daftar Banner',
      resource: permissions.banner,
      action: 'read',
      navActiveLink: 'banners',
      breadcrumb: [
        {
          text: 'Banner',
          active: true,
        },
      ],
    },
  },
  {
    path: '/banners/create',
    name: 'banners-create',
    component: () => import('@/views/banners/create.vue'),
    meta: {
      pageTitle: 'Buat Banner',
      resource: permissions.banner,
      action: 'manage',
      navActiveLink: 'banners',
      breadcrumb: [
        {
          text: 'Banner',
          active: false,
          to: { path: '/banners' },
        },
        {
          text: 'Buat',
          active: true,
        },
      ],
    },
  },
  {
    path: '/banners/:id/edit',
    name: 'banners-edit',
    component: () => import('@/views/banners/edit.vue'),
    meta: {
      pageTitle: 'Edit Banner',
      resource: permissions.banner,
      action: 'manage',
      navActiveLink: 'banners',
      breadcrumb: [
        {
          text: 'Banner',
          active: false,
          to: { path: '/banners' },
        },
        {
          text: 'Edit',
          active: true,
        },
      ],
    },
  },
  {
    path: '/banners/sort',
    name: 'banners-sort',
    component: () => import('@/views/banners/sort.vue'),
    meta: {
      pageTitle: 'Urutan Banner',
      resource: permissions.bannerV2,
      action: 'manage',
      navActiveLink: 'banners-v2',
      breadcrumb: [
        {
          text: 'Banner',
          active: false,
          to: { path: '/v2/banners' },
        },
        {
          text: 'Urutan',
          active: true,
        },
      ],
    },
  },
]
